import { atom } from "jotai";

export enum Tab {
    FULL_MEMO = "Full Memo",
    EXECUTIVE_SUMMARY = "Executive Summary",
    PRE_MEMO = "Pre-Memo",
}

export const tabNavAtom = atom<Tab>(Tab.FULL_MEMO);
export const condensedChartsAtom = atom<boolean>(true);
export const selectedTabAtom = atom<string>("introduction");
